import { render, staticRenderFns } from "./WaitingForDownloadModal.vue?vue&type=template&id=246e9540&"
import script from "./WaitingForDownloadModal.vue?vue&type=script&lang=ts&"
export * from "./WaitingForDownloadModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports